import { UnavailableToWorkTimeSlotViewModel } from '../../entities/UnavailableToWorkTimeSlot/UnavailableToWorkTimeSlot'
import { translate } from '../../helpers/translations/translator'

const getUnavailableToWorkTimeSlotTooltipText = (unavailableWorkTimeSlot: UnavailableToWorkTimeSlotViewModel): string => (
    `${translate('pages.shifts.notAvailable')}: ${unavailableWorkTimeSlot.comment}`
)

export default getUnavailableToWorkTimeSlotTooltipText
